export default {"src":"/_next/static/media/get-started.b94980ff.svg","height":14,"width":14};